/**
 * 器具属性
 * */
export interface IAppliances {
    id: number;
    name: string;
    type: number;
}

export class Appliances implements IAppliances{
    id = 0;
    name = "";
    type = 0;
    imgPath = "";
    imgPathArr = [];

    constructor(r: any) {
        Object.assign(this, r as Appliances);
    }
}
